const clipboardCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.textContent = text;
    document.body.appendChild(textarea);
    const selection = document.getSelection();
    const range = document.createRange();
    range.selectNode(textarea);
    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
    selection === null || selection === void 0 ? void 0 : selection.addRange(range);
    document.execCommand('copy');
    selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
    document.body.removeChild(textarea);
};

export { clipboardCopy };
